import { FileIcon } from '../../../Icons/File';
import { RequiredDocuments } from '../components/RequiredDocuments';
import { VideoTabSection } from '../components/VideoTabSection';

export type THandleNext = () => void;

export type TProductGuideStep = {
  id: string;
  icon?: (color?: string) => JSX.Element;
  title: string;
  content: (handleNext: THandleNext) => JSX.Element;
};

export const PRODUCT_GUIDE_STEPS: TProductGuideStep[] = [
  {
    id: 'linkPanPreFill',
    title: 'Link PAN & Pre-fill',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1718254390_linkpanprefill_v2.mp4"
        handleNext={handleNext}
        thumbnail="https://assets.clear.in/cleartax/images/1718255287_linkpan.png"
      />
    ),
  },
  {
    id: 'form16',
    title: 'Form-16',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898315_form16.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273678_211.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'personalInfo',
    title: 'Personal Information',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898288_personalinfo.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273703_31.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'incomeSources',
    title: 'Income Sources',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898383_incomesources.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273717_41.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'taxSaving',
    title: 'Tax Savings',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898365_taxsaving.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273727_5.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'taxSummaryDeclaration',
    title: 'Tax Summary & Declaration',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898355_taxsummarydeclaration.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273742_6.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'eVerification',
    title: 'e-Verification',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1716898338_everification.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273694_7.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'checkItrStatus',
    title: 'Check ITR Status',
    content: (handleNext: THandleNext) => (
      <VideoTabSection
        video="https://assets.clear.in/cleartax/images/1718254426_checkitrstatus_v2.mp4"
        thumbnail="https://assets.clear.in/cleartax/images/1718273752_8.png"
        handleNext={handleNext}
      />
    ),
  },
  {
    id: 'requiredDocuments',
    icon: (color = '#0E4EA2') => (
      <FileIcon color={color} className="sm:w-5 sm:h-5" />
    ),
    title: ' Required Documents',
    content: () => <RequiredDocuments />,
  },
];
